import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ReferenceLine, ResponsiveContainer, Cell, } from 'recharts';


const BarChartComponent = ({ data, bars }) => {
    return (
        <ResponsiveContainer width="100%" height={300}>
            <BarChart
                data={data}
                stackOffset="sign"
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 35,
                }}
            >
                {/* X-axis: Claims */}
                <XAxis dataKey="name" />
                {/* Y-axis: New Insurance */}
                <YAxis hide domain={['dataMin - 10', 'dataMax + 20']} padding={{ top: 20, bottom: 10 }} // Adds padding to the top and bottom
                    background="#fff" />
                <Tooltip />
                <Legend />

                <ReferenceLine y={-10} stroke="#e0e0e0" strokeWidth={1} />

                {bars.map((bar, index) => (
                    <Bar
                        key={index}
                        dataKey={bar.dataKey}
                        fill={bar.color}
                        stackId="stack"
                        radius={bar.radius}
                    >
                        {data.map((entry, idx) => (
                            <Cell
                                key={`cell-${bar.dataKey}-${idx}`}
                                fill={entry[bar.dataKey] > 0 ? "#F87C2B" : "#4B3ECA"}
                            />

                        ))}
                    </Bar>
                ))}
            </BarChart>
        </ResponsiveContainer>
    );
};

export default BarChartComponent;

